import React, { useState, useEffect } from 'react';

function MultiplayerQuiz({ username, opponentUsername, socket, onFinish }) {
  const [question, setQuestion] = useState(null);
  const [timeLeft, setTimeLeft] = useState(20); // Match backend timer
  const [isAnswered, setIsAnswered] = useState(false); // Track if the player has answered
  const [scores, setScores] = useState({});
  const [gameOver, setGameOver] = useState(false);
  const [winnerMessage, setWinnerMessage] = useState('');
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(null); // Track current question index

  useEffect(() => {
    if (!socket) return;
    console.log(socket);

    // Handlers for server events
    const handleInProgress = (data) => {
      console.log('In-progress state received:', data);
      const { question, scores, questionIndex } = data.game;

      // Only update the state if the question index has changed
      if (questionIndex !== currentQuestionIndex) {
        setQuestion(question);
        setCurrentQuestionIndex(questionIndex); // Update the current question index
        setTimeLeft(20); // Reset the timer
        setIsAnswered(false); // Reset answered state
      }

      // Always update the scores
      setScores(
        scores.reduce((acc, player) => {
          acc[player.username] = player.score;
          return acc;
        }, {})
      );
    };

    const handleGameOver = (data) => {
      console.log('Game Over:', data);
      setGameOver(true);
      setWinnerMessage(data.message || 'Game Over!');
      setScores(
        data.scores.reduce((acc, player) => {
          acc[player.username] = player.score;
          return acc;
        }, {})
      );
    };

    // Attach event listeners
    socket.on('inProgress', handleInProgress);
    socket.on('gameOver', handleGameOver);

    // Timer countdown
    const timerInterval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timerInterval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    // Cleanup
    return () => {
      clearInterval(timerInterval);
      socket.off('inProgress', handleInProgress);
      socket.off('gameOver', handleGameOver);
    };
  }, [socket, currentQuestionIndex]);

  const handleAnswer = (answer) => {
    if (isAnswered) return;
    setIsAnswered(true);
    socket.emit('answer', { answer });
  };

  if (gameOver) {
    return (
      <div className="game-over">
        <h2>Game Over</h2>
        <p>{winnerMessage}</p>
        <ul>
          {Object.entries(scores).map(([playerUsername, playerScore]) => (
            <li key={playerUsername}>
              {playerUsername === username ? 'You' : playerUsername}: {playerScore}
            </li>
          ))}
        </ul>
        <button onClick={onFinish}>Return to Home</button>
      </div>
    );
  }

  return (
    <div className="game">
      <h2>Multiplayer Quiz</h2>
      <p>Opponent: {opponentUsername}</p>
      <div className="timer-container">
        <div
          className="timer-bar"
          style={{
            width: `${(timeLeft / 20) * 100}%`,
            backgroundColor: timeLeft <= 5 ? 'red' : 'green', // Change color when time is low
            transition: 'width 1s linear',
            height: '10px',
          }}
        />
      </div>
      <p>Time Left: {timeLeft}s</p>
      <p>Your Score: {scores[username] || 0}</p>
      <p>Opponent's Score: {scores[opponentUsername] || 0}</p>

      {question && (
        <div>
          <h3>{question.question}</h3>
          <div className="options">
            {question.options.map((option, index) => (
              <button key={index} onClick={() => handleAnswer(option)} disabled={isAnswered}>
                {option}
              </button>
            ))}
          </div>
        </div>
      )}

      {isAnswered && <p>Waiting for opponent...</p>}
    </div>
  );
}

export default MultiplayerQuiz;
